<template>
  <div class="copyplan">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px">
      <div class="inline-block font14px text-bold mb10">目标计划</div>
      <el-form-item label="选择账户：" prop="account_id">
        <jt-new-select v-model="ruleForm.account_id" placeholder="请选择要复制计划的账户，支持名称或ID关键字搜索账户" multiple filterable
          clearable remote collapse-tags collapse-tags-limit="5" :loading="searchLoading" :remote-method="remoteMethod"
          @change="handleAccountChange" style="width: 100%;">
          <el-option :label="item.label" :value="item.value" v-for="item in accountList" :key="item.value"></el-option>
        </jt-new-select>
      </el-form-item>
      <!-- <el-tree :data="treeData" show-checkbox default-expand-all node-key="id" ref="tree" highlight-current
            :props="defaultProps" @check="handleCheckChange" class="custom-tree-oppo" @node-click="handleClickPlan">
            <span class="custom-tree-node" slot-scope="{ data }">
              {{data.label}}
            </span>
          </el-tree> -->
      <el-form-item label="选择计划：" prop="plan_id">
        <jt-new-select :value="ruleForm.plan_id"
          :placeholder="(!ruleForm.account_id || ruleForm.account_id?.length === 0) ? '请先选择账户' : '请选择要复制的计划，支持名称或ID关键字搜索计划'"
          multiple filterable remote :disabled="!ruleForm.account_id || ruleForm.account_id?.length === 0"
          :loading="searchLoading" :filter-method="handleFilterMethod" @remove-tag="handleRemoveTag"
          @clear="handleClear" collapse-tags collapse-tags-limit="5" @visible-change="handleVisibleChange"
          style="width: 100%;">

          <el-tree :data="treeData" show-checkbox default-expand-all node-key="id" ref="tree" highlight-current
            :props="defaultProps" @check="handleCheckChange" class="custom-tree-oppo" @node-click="handleClickPlan">
            <span class="custom-tree-node" slot-scope="{ data }"
              :class="{ 'is-disabled': disabledList.includes(data.id) }">
              <el-option :label="data.label" :value="data.id" class="sc" :disabled="disabledList.includes(data.id)"
                style="display: none;"></el-option>
              {{ data.label }}
            </span>
          </el-tree>
        </jt-new-select>
      </el-form-item>
      <el-form-item>
        <!-- <el-button @click="setCheckedKeys">通过 key 设置</el-button> -->
        <p class="font12px">选择计划后，请点击【添加至已选】，将计划添加至已选账户与计划处，可多次添加，最终复制会按照已选账户与计划进行复制，若未显示对应计划可点击更新计划进行获取</p>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleAddPlan">添加至已选</el-button>
        <!-- <el-button :disabled="disabled" @click="handleUpdatePlan">更新计划{{ disabled ? countdown : null }}</el-button> -->
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import _ from 'lodash'
import API from '@/api/marketManage/oppoCopyPlan.js'
import JtNewSelect from '@/components/Ele/select/src/JtNewSelect.vue'
export default {
  name: 'componentsCopyPlan',
  components: {
    JtNewSelect
  },
  props: {
    config: {
      type: Array,
      default: function () {
        return []
      }
    },
    info: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  watch: {
    'config': {
      handler(val) {
        if (!val) return
        let account_id = []
        if (val.length == 0) {
          account_id = this.ruleForm.account_id = val.map(item => item.id)
          this.ruleForm.plan_id = [] // 清空已选计划
        } else {
          account_id = val.map(item => item.id)
        }
        this.getSelectInfo(val, account_id)
      },
      deep: true,
    },
    'info': {
      handler(val) {
        if (this.$route.params.type == 'copy') {
          this.accountList = val.map(item => {
            return {
              label: item.label,
              value: item.id
            }
          })
          // this.ruleForm.account_id = val.map(item => item.id)
          let account_id = val.map(item => item.id)
          this.getSelectInfo(val, account_id)
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      initData: [{
        id: 1,
        label: '北京惊蛰世纪信息技术有限公司-27-10000037151',
        children: [{
          id: 4,
          label: '124323132-10000037151-2189754654',
        }, {
          id: 9,
          label: '三级 1-1-1'
        }, {
          id: 10,
          label: '三级 1-1-2'
        }
        ]
      }, {
        id: 2,
        label: '海南惶恐信息技术有限公司-029323-3232323',
        children: [{
          id: 5,
          label: '二级 2-1'
        }, {
          id: 6,
          label: '二级 2-2'
        }]
      }],
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      searchLoading: false,
      disabled: false,
      countdown: 120,
      ruleForm: {
        account_id: [], //1000094881
        plan_id: [], //['北京惊蛰世纪信息技术有限公司-27-10000037151', '海南惶恐信息技术有限公司-029323-3232323']
      },
      rules: {
        // account_id: [
        //   { required: true, message: '必填项不可为空', trigger: 'change' }
        // ],
        // plan_id: [
        //   { required: true, message: '必填项不可为空', trigger: 'change' }
        // ]
      },
      accountList: [], // 账户列表
      planList: [], // 计划列表
      emitResult: [],
      disabledList: [], // 禁用的节点ID列表
    }
  },
  created() {
  },
  methods: {
    getSelectInfo(val, ids) {
      if (!val) return
      const validPlanIds = val.reduce((acc, item) => {
        if (item.children) {
          acc.push(...item.children.map(child => Number(child.id)));
        }
        return acc;
      }, []);

      API.getPlanList({
        account_ids: ids,
        search: ''
      }).then(res => {
        let resData = res.data.map(item => {
          return {
            ...item,
            children: item.children.map(plan => {
              return {
                ...plan,
                disabled: validPlanIds.includes(plan.id)
              }
            })
          }
        })
        this.planList = resData
        this.treeData = resData
        this.disabledList = validPlanIds;
      })

    },
    remoteMethod: _.throttle(function (query) {
      if (!query) return
      this.searchLoading = true
      API.getCompanyList({
        search: query
      }).then(res => {
        let resData = res.data.map(item => {
          return {
            label: item.account_name,
            value: item.account_id
          }
        })
        this.accountList = resData.splice(0, 200)
      }).finally(() => {
        this.searchLoading = false
      })
    }, 400),
    handleAccountChange(value) {
      API.getPlanList({
        account_ids: value || this.ruleForm.account_id,
        search: ''
      }).then(res => {
        let resData = res.data.map(item => {
          return {
            ...item,
            children: item.children.map(plan => {
              return {
                ...plan,
                disabled: this.disabledList.includes(plan.id)
              }
            })
          }
        })
        this.planList = resData
        this.treeData = resData

        // 过滤出在treeData中存在的plan_id

        const validPlanIds = _.filter(this.ruleForm.plan_id, id => {
          return _.some(this.treeData, item => {
            if (item.id === id) return true;
            return _.some(item.children || [], child => child.id === id);
          });
        });

        // 更新ruleForm中的plan_id
        this.ruleForm.plan_id = validPlanIds;
      }).finally(() => {
        this.$refs.tree.setCheckedKeys(this.ruleForm.plan_id);
      })
    },
    // 自定义搜索方法 只搜索lable 一级label搜索到了 就不会再去搜索children，所以需要递归
    handleFilterMethod: _.throttle(function (query) {
      let cloneData = ''
      if (!query) {
        return
      }
      cloneData = _.cloneDeep(this.planList)
      // 定义递归函数来过滤树数据
      const filterTree = (nodes) => {
        return nodes.filter(node => {
          // 同时匹配label和id
          if (node.label.indexOf(query) !== -1 || String(node.id).indexOf(query) !== -1) {
            return true;
          } else if (node.children) {
            const filteredChildren = filterTree(node.children);
            if (filteredChildren.length > 0) {
              // 如果子节点有匹配的，保留当前节点
              node.children = filteredChildren;
              return true;
            }
          }
          return false;
        });
      };
      let currentLabel = filterTree(cloneData);
      this.treeData = currentLabel.map(item => {
        return {
          ...item,
          children: item.children.map(plan => {
            return {
              ...plan,
              disabled: this.disabledList.includes(plan.id)
            }
          })
        }
      })
      this.$nextTick(() => {
        this.$refs.tree.setCheckedKeys(this.ruleForm.plan_id);
      })
    }, 400),
    filterTreeByIds(tree, ids) {
      // 深拷贝原数据，避免修改原数据
      const copiedTree = _.cloneDeep(tree);
      return copiedTree.filter(node => {
        if (ids.includes(Number(node.id))) {
          return true;
        } else if (node.children) {
          const filteredChildren = this.filterTreeByIds(node.children, ids);
          if (filteredChildren.length > 0) {
            node.children = filteredChildren;
            return true;
          }
        }
        return false;
      });
    },
    handleCheckChange(data, checked) {
      let currentTreeData = []
      this.treeData.forEach(item => {
        item.children.forEach(plan => {
          if (!plan.disabled) {
            currentTreeData.push(plan.id)
          }
        })
      })
      
      let selectedIds = checked.checkedKeys.map(v => Number(v))

      let unCheckedKeys = _.without(currentTreeData, ...selectedIds)

      let without = _.without([...selectedIds], ...this.ruleForm.account_id.map(v => Number(v)))

      let checkedKeys = _.without(this.ruleForm.plan_id, ...unCheckedKeys)
      this.ruleForm.plan_id = _.uniqBy([...without, ...checkedKeys])
    },
    handleClickPlan(data) {
      if (data?.disabled) {
        return
      }
      if(this.ruleForm.account_id.includes(data.id)) {
        return
      }
      if (this.ruleForm.plan_id.includes(data.id)) {
        this.ruleForm.plan_id = _.without(this.ruleForm.plan_id, data.id)
      } else {
        this.ruleForm.plan_id = [...this.ruleForm.plan_id, data.id]
      }
      this.$nextTick(() => {
        this.$refs.tree.setCheckedKeys(this.ruleForm.plan_id);
      })
    },
    handleRemoveTag(value) {
      let without = _.without([...this.ruleForm.plan_id], value)
      this.$refs.tree.setCheckedKeys(without);   // 目前只设置chidlren 二级选中keys
      this.ruleForm.plan_id = without
      this.treeData = this.treeData.map(item => {
        return {
          ...item,
          children: item.children.map(plan => {
            return {
              ...plan,
              disabled: this.disabledList.includes(plan.id)
            }
          })
        }
      })
      // const filteredData = this.filterTreeByIds(this.planList, this.ruleForm.plan_id);
      // this.emitResult = filteredData
    },
    handleClear() {
      this.$refs.tree.setCheckedKeys([]);   // 目前只设置chidlren 二级选中keys
      this.ruleForm.plan_id = []
    },
    handleVisibleChange(visible) {
      if (!visible) {
        // this.handleFilterMethod()
        let cloneData = _.cloneDeep(this.planList)
        this.treeData = cloneData.map(item => {
          return {
            ...item,
            children: item.children.map(plan => {
              return {
                ...plan,
                disabled: this.disabledList.includes(plan.id)
              }
            })
          }
        })
        this.$nextTick(() => {
          this.$refs.tree.setCheckedKeys(this.ruleForm.plan_id);
        })
      }
    },
    startCountdown() {
      // 每秒更新倒计时
      let countdownInterval = ''
      if (countdownInterval) clearInterval(countdownInterval);
      countdownInterval = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(countdownInterval);
        }
      }, 1000);
    },
    handleUpdatePlan: (function () {
      if (this.ruleForm.account_id.length == 0) {
        return this.$message.warning('请选择账户')
      }
      this.disabled = true

      this.$notify({
        title: '提示',
        message: '请求成功，正在更新，请稍后...',
        duration: 0
      });

      API.postUpdatePlan({
        account_id: this.ruleForm.account_id,
      }).then(res => {
        this.$message.success(res.info);

        this.$notify.closeAll()
        this.$notify({
          title: '提示',
          message: '更新成功',
          duration: 3
        });


        this.startCountdown()
        setTimeout(() => {
          this.disabled = false
          this.countdown = 120; // 设置倒计时为5秒
        }, 120 * 1000)
      }).catch(err => {
        this.disabled = false
        this.$message.error(err.info);
        this.$notify.closeAll()
        this.$notify({
          title: '提示',
          message: err.info,
          duration: 0
        });
      })

    }),
    handleAddPlan() {

      if (this.ruleForm.plan_id.length == 0) {
        return this.$message.warning('请选择计划')
      }

      const filteredDisableData = this.filterTreeByIds(this.planList, this.disabledList);
      const filteredData = this.filterTreeByIds(this.planList, this.ruleForm.plan_id);
      this.emitResult = filteredData
      this.$emit('addPlan', { plan: this.emitResult, disabledList: filteredDisableData })

      this.ruleForm.account_id = []
      this.ruleForm.plan_id = []
    },
    submitForm() {
      return new Promise((resolve, reject) => {
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            resolve(this.ruleForm)
          } else {
            reject()
          }
        })
      })
    }

  }
}
</script>
<style lang="scss">
.custom-tree-oppo {
  .custom-tree-node {
    .el-select-dropdown__item.selected {
      &::after {
        display: none !important;
      }

      &.is-disabled {
        color: #bbbbbb !important;
      }
    }

    .el-select-dropdown.is-multiple .el-select-dropdown__item.selected.hover {
      background-color: transparent !important;
    }

    .el-select-dropdown__item.hover,
    .el-select-dropdown__item:hover {
      background-color: transparent !important;
    }

    &.is-disabled {
      color: #bbbbbb !important;
    }
  }

}
</style>